import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import loader from '../../../assets/loading.gif';
import './NextButton.scss';

const NextButton = props => (
  <section>
    <div className="container">
      <div className="row">
        <div className="col-sm-12 ca-button-container">
          {props.handlePrevious &&
          <Button
            id="ca-previous-button"
            type="button"
            className="secondary"
            disabled={props.disabled}
            onClick={props.handlePrevious}
          >
            Previous
          </Button>
          }
          {!props.success &&
          <Button
            id="submit-checkout-button"
            type="submit"
            disabled={props.disabled}
            onClick={props.handleClick}
          >
            {props.submitting ?
              <img
                src={loader}
                height="20"
                alt="Loading..."
                role="presentation"
              /> : 'Next'}
          </Button>
          }
          {props.success &&
          <Button
            id="ca-success-button"
            className="success-button"
            type="submit"
            disabled={props.disabled}
            onClick={props.handleClick}
          >
            <div id="ca-success-checkmark" className="checkmark draw" />
          </Button>
          }
        </div>
      </div>
    </div>
  </section>
);

NextButton.propTypes = {
  handleClick: PropTypes.func,
  handlePrevious: PropTypes.func,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  success: PropTypes.bool
};

export default NextButton;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/NextButton/NextButton.js
 **/